import { Blocs } from '@business/blocs';
import { MessageKind, UserMessage } from '@business/entities/account';
import { GlobalNotification } from '@business/entities/common';
import { JobResponse } from '@business/entities/job';
// import { JobResponse } from '@business/entities/job';
import { FlashMessage } from '@core/components/FlashMessage';
import { BaseBloc } from '@core/utils/bloc';
import { Echo } from '@core/utils/echo/echo';
// import { gcLabel } from '@core/utils/hooks/misc/gcLabel';
import { resolve } from '@core/utils/ioc';
import { R } from '@core/utils/r';
import { Session } from '@modules/auth/session';
import { Subject } from 'rxjs';

export class EchoBloc extends BaseBloc {
  private echo: Echo | null = null;

  onInit() {
    this.echo = new Echo();
    this.subscribeToUserChannel();
    this.subscribeToTenantChannel();
  }

  onReset() {
    this.echo?.disconnect();
  }

  subscribe<T = any>(channelName: string, event?: string) {
    const obs$ = new Subject<T>();
    this.echo?.subscribe<T>(channelName, event, data => {
      obs$.next(data);
    });
    return obs$;
  }

  unsubscribe(channelName: string) {
    this.echo?.leave(channelName);
  }

  handleUserMessage(message: UserMessage) {
    // switch (message.kind) {
    //   case MessageKind.jobs: {
    //     resolve(Blocs.job).fetchJobs().subscribe();
    //     if (message.data && R.get(message, 'data.success')) {
    //       resolve(Blocs.job).handleJobCompletion(message.data as JobResponse);
    //     }
    //     break;
    //   }
    // }
  }

  subscribeToUserChannel() {
    // if (Session.user) {
    //   this.echo?.subscribe<UserMessage>(`App.Models.User.${Session.user.id}`, undefined, data => {
    //     this.handleUserMessage(data);
    //   });
    // }
  }

  subscribeToTenantChannel() {
    // this.echo?.subscribe<GlobalNotification>(`YESA`, undefined, data => {
    //   if (data.type === 'App\\Notifications\\AppUpdateNotification') {
    //     FlashMessage.info('App Update', 'There is a new version of the app available ', {
    //       buttons: [FlashMessage.button('Reload', 'info', () => document.location.reload())],
    //       autoHide: false,
    //       duration: 10000,
    //       progressBar: false,
    //       layout: 'bottomRight',
    //     });
    //   }
    // });
  }
}
